import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconUser, IconChevronDown, IconLogout } from '@tabler/icons-react';
import Transition from '../utils/Transition';
import ModalLogout from './ModalLogout';

function UserMenu() {
  const user = localStorage.getItem('name');
  const role = localStorage.getItem('role');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef(null);
  const dropdown = useRef(null);
  const navigate = useNavigate();

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  function logOut() {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('toko');
    window.dispatchEvent(new Event('logout-success'));
    navigate('/login');
  }

  const [isOpenModalLogout, setIsOpenModalLogout] = useState(false);

  function closeModalLogout() {
    setIsOpenModalLogout(false);
  }

  return (
    <div className="relative inline-flex">
      <ModalLogout isOpenModalLogout={isOpenModalLogout} closeModaLogout={closeModalLogout} logout={logOut} />
      <button
        ref={trigger}
        className="inline-flex justify-center items-center group py-1 px-1.5 sm:px-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors focus:outline-none"
        aria-haspopup="true"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-expanded={dropdownOpen}
      >
        <div className="flex items-center">
          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-amber-500/15 dark:bg-amber-500/20 text-amber-600 dark:text-amber-400 flex items-center justify-center border border-amber-500/30 flex-shrink-0">
            <IconUser size={16} stroke={2} />
          </div>
          <span className="truncate max-w-[110px] sm:max-w-none ml-2 text-sm font-medium text-slate-700 dark:text-slate-200 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors">
            {user}
          </span>
          <IconChevronDown
            size={14}
            className={`shrink-0 ml-1.5 text-slate-400 transition-transform duration-200 ${
              dropdownOpen ? 'rotate-180 text-amber-600 dark:text-amber-400' : 'group-hover:text-amber-600 dark:group-hover:text-amber-400'
            }`}
          />
        </div>
      </button>
      <Transition
        className="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 py-1.5 rounded-xl shadow-xl overflow-hidden mt-1 transition-colors"
        show={dropdownOpen}
        enter="transition ease-out duration-200 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div ref={dropdown} onFocus={() => setDropdownOpen(true)} onBlur={() => setDropdownOpen(false)}>
          <div className="pt-2 pb-2.5 px-3.5 mb-1 border-b border-slate-200 dark:border-slate-700 flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-amber-500/15 dark:bg-amber-500/25 text-amber-600 dark:text-amber-400 flex items-center justify-center shrink-0 border border-amber-500/20 font-bold text-xs">
              <IconUser size={16} />
            </div>
            <div className="min-w-0">
              <div className="font-semibold text-xs sm:text-sm text-slate-800 dark:text-slate-100 truncate">{user}</div>
              <div className="text-[11px] text-slate-500 dark:text-slate-400 capitalize">{role || 'User'}</div>
            </div>
          </div>
          <ul className="py-1">
            <li>
              <button
                type="button"
                className="w-full font-medium text-sm text-rose-500 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/30 flex items-center gap-2 py-1.5 px-3.5 transition-colors text-left"
                onClick={logOut}
              >
                <IconLogout size={16} />
                <span>Log Out</span>
              </button>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  );
}

export default UserMenu;
